<template>
  <div class="main-conent main-conent-maxheight main-content-rows page-me">
    <div class="title">
      <el-breadcrumb size="medium">
        <el-breadcrumb-item>账号中心</el-breadcrumb-item>
        <el-breadcrumb-item>用户信息</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="cards-wrap">
      <div class="content">
        <el-form label-width="80px" size="medium">
          <el-form-item label="账号：">
            <span class="form-value">{{ info.name }}</span>
          </el-form-item>

          <el-form-item>
            <el-button
              icon="el-icon-lock"
              type="info"
              size="small"
              @click="goReset"
            >
              重置密码
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <resetor ref="restor" :username="info.name" />
  </div>
</template>

<script>
import Resetor from './ResetPassword'

export default {
  components: { Resetor },
  data() {
    return {
      loading: false
    }
  },
  computed: {
    info() {
      return this.$store.getters.user
    }
  },
  methods: {
    goReset() {
      this.$refs.restor.open()
    }
  }
}
</script>

<style lang="scss">
.page-me {
  .title {
    padding: 20px;
    font-size: 1rem;
    border-bottom: 1px dashed #d1d1d1;
    background-color: #fff;
    .el-breadcrumb {
      font-size: 1rem;
      user-select: none;
    }
  }

  .cards-wrap {
    padding: 20px;
    .content {
      padding: 36px;
      background-color: #fff;
      font-size: 1rem;
    }
    .form-value {
      color: #909399;
    }
  }

  .el-input {
    width: 240px;
  }
}
</style>
